var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvivaLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Logo",
    viewBox: "0 0 226.772 40.64",
    width: 226.772,
    height: 40.64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, "\n      .cls-1{fill:#191d64;stroke-width:0}\n    "))), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "M133.32 1.057c.726.131 3.331.89 3.331 2.74v29.64h8.81V.002H133.32z",
    className: "cls-1",
    style: {
      fill: "#191d64",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "m66.261 20.112 5.904-13.154 5.156 13.154zM64.037.002v1.055c1.067.224 3.38.868 2.444 2.956L53.34 33.439h6.942l4.115-9.173h14.554l3.599 9.173h9.127L78.638.001Z",
    className: "cls-1",
    style: {
      fill: "#191d64",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "m201.351 20.112 5.901-13.154 5.16 13.154zM199.126.002v1.055c1.064.224 3.382.868 2.442 2.956L188.43 33.439h6.943l4.107-9.173h14.556l3.6 9.173h9.135L213.725 0h-14.599z",
    className: "cls-1",
    style: {
      fill: "#191d64",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "M175.687 33.438 189.62 0h-6.588l-10.219 24.52L163.092 0h-12.384v1.058c1.43.274 3.036.889 3.769 2.738l11.753 29.642z",
    className: "cls-1",
    style: {
      fill: "#191d64",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M114.612 33.438 128.55 0h-6.593l-10.215 24.52L102.015 0h-12.38v1.058c1.432.274 3.033.889 3.77 2.738l11.747 29.642Z",
    className: "cls-1",
    style: {
      fill: "#191d64",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M40.738 33.423 40.75.005 29.476 0v.004l3.269 33.662c2.61-.153 5.274-.24 7.993-.244",
    className: "cls-1",
    style: {
      fill: "#191d64",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M26.156 34.228 29.476.005V0L0 .005.015 40.64c6.925-3.027 15.94-5.283 26.141-6.412",
    className: "cls-1",
    style: {
      fill: "#191d64",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvivaLogo);
export default __webpack_public_path__ + "static/media/aviva-logo.16236db01510dc8b7bcb4db10855283b.svg";
export { ForwardRef as ReactComponent };